<div *ngFor="let description of descriptions" >
    <div *ngIf="globals.getLocalizedValue(description?.text)">
        <div *ngIf="description.value.length > 0" class="education-content">
            <div>
                <b>{{globals.getLocalizedValue(description.descriptionField.title)}}</b>
                <p>
                    <app-markdown [body]="globals.getLocalizedValue(description?.text)"></app-markdown>
                </p>
            </div>
        </div>
    </div>
</div>